function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6DC4F2",
  d: "M51.37 20.964l-11.387-1.598 4.329-10.801c.69-1.723-1.201-3.331-2.753-2.343l-9.735 6.2-3.528-11.095C28.015.442 27.257 0 26.5 0c-.758 0-1.516.442-1.796 1.327l-3.53 11.096-9.734-6.2c-1.552-.988-3.442.62-2.752 2.343l4.329 10.8L1.63 20.965c-1.816.255-2.244 2.72-.624 3.589l10.16 5.451-7.709 8.648c-1.13 1.268-.178 3.201 1.376 3.201.135 0 .276-.014.421-.046l11.239-2.448-.426 11.65c-.044 1.206.918 1.99 1.906 1.99.533 0 1.076-.229 1.47-.743l7.058-9.203 7.057 9.203c.395.514.936.743 1.47.743.988 0 1.95-.784 1.906-1.99l-.425-11.65 11.238 2.448c1.797.39 3.024-1.78 1.796-3.156l-7.71-8.648 10.161-5.451c1.62-.869 1.19-3.333-.625-3.588zm-16.33 11.3l-5.37-1.17.203 5.568-3.373-4.398-3.374 4.398.203-5.568-5.372 1.17 3.686-4.134-4.857-2.605 5.441-.764-2.069-5.162 4.653 2.962 1.689-5.303 1.686 5.303 4.653-2.962-2.07 5.162 5.442.764-4.856 2.605 3.686 4.134z"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0H53V53H0z"
})));
function SvgBlueStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    fill: "none",
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStar);
export default __webpack_public_path__ + "static/media/blue_star.e7f66693d8b1af1e0965a80e4346078a.svg";
export { ForwardRef as ReactComponent };